import { render } from "./ProjectsSlideType.vue?vue&type=template&id=483aff1b&scoped=true"
import script from "./ProjectsSlideType.vue?vue&type=script&lang=js"
export * from "./ProjectsSlideType.vue?vue&type=script&lang=js"

import "./ProjectsSlideType.vue?vue&type=style&index=0&id=483aff1b&lang=scss&scoped=true"

import exportComponent from "/Users/nigomatulin/projects/WOPA/tverstroyka/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483aff1b"]])

export default __exports__